import { debugInfo } from '@vfde-sails/utils';
import { HtmlId } from '../enum';

/**
 * Update HookList with new list items.
 * @param {HTMLUListElement | null} comp - element to update
 * @param {string[]} data - string[] to be used as list items
 */
export const updateHookList = (comp: HTMLUListElement | null, data: string[]) => {
    if (!comp) {
        return;
    }

    comp.innerHTML = '';

    for (const text of data) {
        const li = document.createElement('li');

        li.innerHTML = text;

        comp.appendChild(li);
    }
};

/**
 * Create HookList component.
 * @param {HtmlId} id - ID of the element.
 * @param {string[]} data - string[] to be used to create list items
 * @returns {HTMLUListElement | null} component or null if element with given id is not found
 */
export const mountHookList = (id: HtmlId, data: string[]) => {
    const listEl = document.getElementById(id)?.getElementsByTagName('ul')[0];

    if (!listEl || !(listEl instanceof HTMLUListElement) || !data) {
        debugInfo('Cant mount hooklist with id: ', id);

        return null;
    }

    updateHookList(listEl, data);

    return listEl;
};
